import { useFieldArray, useFormContext } from "react-hook-form";
import { IUser } from "../../../types/Auth/user";
import PermissionTable from "./PermissionTable";
import { settingPermissionValue } from "../../../utils/Permission/Setting";

const SettingPermissionTable = () => {
  const { control, watch } = useFormContext<IUser>();
  const { fields, replace } = useFieldArray({
    control,
    name: "setting_permission",
    keyName: "genId",
  });

  const watchFieldArray = watch("setting_permission");

  const controlledFields = fields.map((field, index) => {
    return {
      ...field,
      ...(watchFieldArray &&
        watchFieldArray.length > 0 &&
        watchFieldArray[index]),
    };
  });

  const resetArrayHandler = () => {
    replace(settingPermissionValue);
  };

  return (
    <PermissionTable
      module={"setting_permission"}
      controlledFields={controlledFields}
      resetArrayHandler={resetArrayHandler}
    />
  );
};

export default SettingPermissionTable;
